<template>
  <main-container>
    <common-header/>
    <section-heading>電話番号選択</section-heading>
    <contents-container>
      <error-box v-if="isError">
        <p v-for="(message, index) in $_errorMessages" :key="index">{{message.errorMessage}}</p>
      </error-box>

      <item-container>
        <heading-label>申請されるiPhone/iPadの電話番号</heading-label>
        <contents-text>
          <small-text>申請する端末の電話番号を選択してください。</small-text>
        </contents-text>
        <form-select
            v-model="tel"
            name="tel"
            :disabled="isAnotherTel.length > 0"
            :options="telOption"
            :error="'tel' in errorMessage"
        ></form-select>
        <form-checkbox
            v-model="isAnotherTel"
            name="isAnotherTel"
            :options="anotherTelOption"
        ></form-checkbox>
        <error-message v-if="'tel' in errorMessage">{{errorMessage.tel}}</error-message>
        <contents-text class="mt10">
          <small-text>
            au回線/UQ回線をご契約で申請を希望される電話番号がリストにない場合は、auIDをご確認の上、再度ログインをお願いいたします。
            <br>
            →再度ログインを頂いても、電話番号がリストに表示されない場合は、修理代金サポートセンターへお問い合わせください。
          </small-text>
        </contents-text>
        <contents-text>
          <small-text>
            修理代金サポートでは、申請を希望される電話番号のauIDでログインする必要がございます。
          </small-text>
        </contents-text>
      </item-container>
      <button-container>
        <button-main variant="next" @click="next">次へ進む</button-main>
      </button-container>
      <button-container>
        <button-main :to="{name: 'rep010', params: {id: this.$route.query.p}}">戻る</button-main>
      </button-container>
      <common-support/>
    </contents-container>
    <common-footer/>
    <common-loading v-if="isLoading"/>
  </main-container>
</template>

<script>
  import CommonHeader from '../components/common/CommonHeader'
  import CommonFooter from '../components/common/CommonFooter'
  import CommonSupport from '../components/common/CommonSupport'
  import CommonLoading from "../components/common/CommonLoading"
  import MainContainer from '../components/container/MainContainer'
  import SectionHeading from '../components/heading/SectionHeading'
  import ContentsContainer from '../components/container/ContentsContainer'
  import ItemContainer from "../components/container/ItemContainer"
  import HeadingLabel from "../components/heading/HeadingLabel"
  import ContentsText from '../components/text/ContentsText'
  import SmallText from "../components/text/SmallText"
  import FormSelect from "../components/select/FormSelect"
  import FormCheckbox from "../components/select/FormCheckbox"
  import ErrorBox from "../components/error/ErrorBox"
  import ErrorMessage from "../components/error/ErrorMessage"
  import ButtonContainer from "../components/button/ButtonContainer"
  import ButtonMain from "../components/button/ButtonMain"

  import ErrorMixin from "../components/mixin/ErrorMixin";

  import {postClaimTelListApi, postClaimPatternApi} from '../utils/ApiHelper'

  export default {
    name: "rep020",
    components: {
      CommonHeader,
      CommonFooter,
      CommonSupport,
      CommonLoading,
      MainContainer,
      SectionHeading,
      ContentsContainer,
      ItemContainer,
      HeadingLabel,
      ContentsText,
      SmallText,
      FormSelect,
      FormCheckbox,
      ErrorBox,
      ErrorMessage,
      ButtonContainer,
      ButtonMain
    },
    mixins: [ErrorMixin],
    data () {
      return {
        form: {
          tel: "",
          isAnotherTel: false,
          referrerInfo: Number(this.$route.query.p)
        },
        tel: "",
        isAnotherTel: [],
        isLoading: false,
        telList: []
      }
    },
    computed: {
      telOption () {
        let options = [{label: '選択', value: '', disabled: true}]
        for (let tel of this.telList) {
          options.push({label: tel, value: tel, disabled: false})
        }
        return options
      },
      anotherTelOption () {
        return [{label: 'au契約以外/UQ契約以外の方', value: 'another'}]
      },
      errors() {
        return this.$_validationErrors
      },
      isError () {
        return this.errors.length > 0
      },
      errorMessage () {
        let errorMessage = {}
        for (const error of this.errors) {
          if (error.errorItem) {
            errorMessage[error.errorItem] = error.errorMessage
          }
        }
        return errorMessage
      }
    },
    methods: {
      next () {
        if (this.isLoading) return false
        this.isLoading = true
        this.$_clearError()

        this.form.tel = this.form.isAnotherTel ? '' : this.tel
        this.form.isAnotherTel = this.isAnotherTel.includes('another')
        postClaimPatternApi(this.form)
        .then(res => {
          const result = res.data.result
          if (!this.$_isError(result)) {
            if ('messages' in result) {
              this.$store.dispatch('setErrorMessage', result.messages[0].message)
              this.$router.push({name: result.messages[0].pageId, query: {'p': this.$route.query.p}})
            } else if ('rescuePattern' in result) {
              this.$store.dispatch('setRescuePattern', result.rescuePattern)
              this.$store.dispatch('setClaimPattern', this.form)
              this.$store.dispatch('setCarrierType', result.carrierType)
              this.$router.push({name: 'rep190', query: {'p': this.$route.query.p}})
            } else {
              let claimInit = {
                tel: this.form.tel,
                isUpdate: false,
                pageId: result.pageId,
                isAnotherTel: this.form.isAnotherTel
              }
              this.$store.dispatch('setClaimInit', claimInit)
              this.$store.dispatch('setCarrierType', result.carrierType)
              this.$router.push({name: result.pageId, query: {'p': this.$route.query.p}})
            }
          }
          this.isLoading = false
        })
        .catch(() => {
          this.$router.push({name: 'rep320', query: {'p': this.$route.query.p}})
        })
      }
    },
    mounted () {
      this.isLoading = true
      postClaimTelListApi()
      .then(res => {
        const result = res.data.result
        this.$_isError(result)
        this.telList = result.telList
        this.isLoading = false
      })
      .catch(() => {
        this.$router.push({name: 'rep320', query: {'p': this.$route.query.p}})
      })
    }
  }
</script>
<style lang="scss" scoped>
  .form-checkbox {
    margin-top: 10px;
  }
  .mt10 {
    margin-top: 10px;
  }
</style>
